import { ErrorMessage, KngButtonState, KngFooterState, ModalState } from 'kinetic-angular';
import { UserProfile, VertexAPIValidationLabels, IdLabelPair, Role, Address, Image, TokenData, LocationAddress, VertexAPIAddressValidationFailedLabels, VerifyRoleLabels } from '../../../services/shared/shared-interface';
import { UserRegistrationStatusValue } from '../../../services/api/definitions';
import { UploadFileSection } from 'projects/kinetic-angular/src/lib/components/upload-file';
import { CommonErrorState } from '../../common-error';
export interface Registration {
  state: RegistrationState;
}
export interface RegistrationState {
	tempFlag: boolean;
	tempIsPrefilled: boolean;
	crmPrefill: boolean;
	firstName: string;
	lastName: string;
	phoneNumber: string;
	jobTitle: IdLabelPair[];
	requestedRole: Role[];
	companyDetails: CompanyDetailsSection;
	addressDetails: Address;
	accountName: string;
	email: string;
	submitButton: KngButtonState;
	verifyInformationButton: KngButtonState;
	modifyDetailsButton: KngButtonState;
	continueButton: KngButtonState;
	contactDealerButton: KngButtonState;
	disagreeButton: KngButtonState;
	termsAgreeButton: KngButtonState;
	policyAgreeButton: KngButtonState;
	termsModal: ModalState;
	policyModal: ModalState;
	footer: KngFooterState;
	registrationPage: RegistrationPage;
	dealerInfo: DealerInfo | undefined;
	loading: boolean;
	profileInformation: UserProfile;
	vertexAPIValidationLabels: VertexAPIValidationLabels;
	mapVertexAddressFailedLabels: VertexAPIAddressValidationFailedLabels;
	mapVerifyRoleLabels: VerifyRoleLabels;
	errorText: RegistrationFormError;
	additionalLocationList: AdditionalLocationListResponse;
	additionalLocationGridHeaderDesktop: string[];
	additionalLocationGrid: GridData[];
	additionalLocationError?: ErrorMessage;
	ribbonClearButton: KngButtonState;
	additionalLocationSubmitButton: KngButtonState;
	businessRegistrationFlowSubmitModalLabels: BusinessRegistrationFlowSubmitModalLabels;
	uploadFileSection: UploadFileLabels;
}

export interface BusinessRegistrationFlowSubmitModalLabels {
	heading: string;
	closeIcon: Image;
	cancel: string;
	proceed: string;
}
export interface UploadFileLabels {
	heading: string;
	subHeading: string;
	closeIcon: Image;
	cancel: string;
	upload: string;
	close: string;
	download: DownloadTemplate;
	uploadFile: UploadFileSection;
	errorState:CommonErrorState;
	content: [{
		label: string;
		description: string;
	}];
  }
export interface DownloadTemplate{
	downloadButton:string;
	errorMessage:string;
}
export interface AdditionalLocationListResponse {
	primaryLocationInfo: {
		primaryLocationGRID: string;
		adminLocationID: string;
		topLevelGrid: string;
		companyName: string;
		addressLine1: string;
		addressLine2: string;
		city: string;
		state: string;
		zipCode: string;
		country: string;
	};
	locationList: LocationList[];
	pendingLocationDetails: {
		originalFileName: string;
		updatedFileName: string;
	  };
}
export interface GridData {
	locationGRID: string;
	companyName: string;
	address: string;
	country: string;
	checked:boolean;
}
export interface LocationList {
	locationGRID: string;
	companyName: string;
	addressLine1: string;
	addressLine2?: string;
	city: string;
	state: string;
	zipCode: string;
	country: string;
}
export interface CompanyDetailsSection {
	addressLine1 : string;
	addressLine2: string;
	companyName : string;
  	country: string;
	state : string;
	zipCode: string;
	city: string;
}

export interface SubmitBusinessPayload
{
	selectedLocationList:LocationList[];
	selectionMethod: LocationSelectionMethod;
	claimDomain: boolean;
}

export type LocationSelectionMethod = 'manual' | 'fileupload' | 'document';

export interface SaveUserPayload extends LocationAddress{
	accountName: string;
	city: string;
	email: string;
	firstName: string;
	jobTitle: string;
	lastName: string;
	phoneNumber: string;
	requestedRole: string;
	crmPrefill: boolean;
	proceedWithInputtedAddress?: boolean;
}

export interface DealerInfo {
	address: string;
	dealerName: string;
	email: string;
	phoneNumber: string;
}

export interface DealerData {
	successMessage?: string;
	errorMessage?: string;
	dealerInfo?: DealerInfo;
	registrationStatus?: string;
	requestType?: string;
	orgAdminPending?: boolean;
}

export interface RegistrationPage {
	companyDetails: CompanyDetails;
	companyError: CompanyError;
	logo: Image;
	logoutLabel: string;
	pageDescription: string;
	pageHeading: string;
	profileInfo: ProfileInfo;
	stepLabel: string;
	submitButton: string;
	termsConditions: TermConditions;
	privacypolicy:PrivacyPolicy;
	accountType: AccountType;
	additionalLocation: AdditionalLocations;
	domainInfo: DomainLabels;
}

export interface CompanyDetails {
	addressLine1: string;
	addressLine2: string;
	address2OptionalLabel: string;
	city: string;
	companyName: string;
	description: string;
	heading: string;
	logo: Image;
    country: string;
	state: string;
	stateAltText: string;
	stepNumber: string;
	zipCode: string;
	companyNotFoundErrorModalDescription: string;
	companyNotFoundErrorModalHeader: string;
}

export interface CompanyError {
	messageMain: string;
	messageSub: string;
	actionMessage: string;
	phoneNumber: {
		label: string;
		value: string;
	};
	email: {
		label: string;
		value: string;
	};
	customerServiceName: string;
	address: string;
	contactDealer: {
		label: string;
		icon: string;
	};
}


export interface ProfileInfo {
	description: string;
	emailAddress: string;
	firstName: string;
	heading: string;
	jobTitle: string;
	jobTitleAltText: string;
	lastName: string;
	logo: Image;
	phoneNumber: string;
	requestedRole: RequestedRole;
	requestedRoleAltText: string;
	stepNumber: string;
}

export interface TermConditions {
	description: string;
	heading: string;
	logo: Image;
	privacy: ModalData;
	stepNumber: string;
	terms: ModalData;
}

export interface AccountType {
	description?: string;
	heading: string;
	logo: Image;
	stepNumber: string;
	individualAccount: AccountDetails;
	businessAccount: AccountDetails;
}

export interface AccountDetails {
	label: string;
	description1: string;
	description2: string;
	tokenData: Array<TokenData>;
}

export interface AdditionalLocations {
	locationPageDescription: LocationPageDescription;
	heading1: string;
	headingOr: string;
	heading2: UploadLocationList;
	logo: Image;
	stepNumber: string;
	primaryLocationHeading: string;
	selectLocationTableHeader: {
		companyName: string;
		address: string;
		country: string;
		selectAll: string;
	};
	uploadSuccessText: string;
	uploadSuccessSubtext: string;
}

export interface UploadLocationList {
	label: string;
	iconPath: string;
	altText: string;
  }
export interface LocationPageDescription {
	description1: string;
	description2: string;
	tokenData: Array<TokenData>;
}
export interface PrivacyPolicy {
	description: string;
	heading: string;
	logo: Image;
	privacy: ModalData;
	stepNumber: string;
	terms: ModalData;
}

export interface ModalData {
	infoBanner?: string;
	label: string;
	modal: ModalDetails;
	tokenData: Array<TokenData>;
}

export interface ModalDetails {
	agreeButtonLabel: string;
	agreedButtonLabel: string;
	closeIcon: Image;
	content: Array<string>;
	disagreeButtonLabel: string;
	heading: string;
	checkboxText: string;
}

export interface RequestedRole {
	label: string;
	description: string;
}
export interface RegistrationResponse {
	'registration-page': RegistrationPage;
}
export interface RegistrationFormError {
    invalidCharacterWithNumericErrorMessage: string;
    requiredErrorMessage: string;
    requiredDropdownErrorMessage: string;
    minLengthZipCodeError: string;
    canadaPostalCodeFormatError: string;
    phoneLength: string;
    phoneSameNumber: string;
    phoneSequenceNumber: string;
}
export interface SubmitRegistrationResponse{
	successMessage: string;
    registrationStatus: UserRegistrationStatusValue;
    requestType:string;
}

export interface SaveBusinessAccountResponse {
    registrationStatus: UserRegistrationStatusValue;
	userStatus: string;
}

export interface DomainLabels{
	heading: string;
	description: string;
	stepNumber: string;
	subHeading: string;
	logo: Image;
	labelPrefix: string;
	labelSuffix: string;
}
